import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import config from '../../config';
import { newEle, sanitizedHTML } from '../../utils/Helper';

import { version } from '../../../package.json';

const Footer = ({ ...props }) => {
  const { match = {}, siteConfig } = props;
  const { data = {} } = siteConfig || {};
  const { custom_footer = false, defaultLanguage } = data;

  useEffect(() => {
    if (defaultLanguage) {
      const curLang = match.params.locale || defaultLanguage;
      genFootJS(curLang);
    }
  }, [match.params.locale, defaultLanguage]);

  useEffect(() => {
    genVersion();
  }, []);

  // TODO: change src to use env variable
  const genFootJS = (lang) => {
    const { footer_config = '' } = data[lang] || {};

    if (custom_footer) {
      const footerEle = document.getElementById('subportal-footer');
      footerEle.innerHTML = sanitizedHTML(footer_config.custom_footer_html);
    } else if (custom_footer === false) {
      newEle(
        'subportal-footer-js',
        config.scriptUrl.footer.replace('%%%lang%%%', lang),
        document.body,
        'script',
        'text/javascript',
      );
    }
  };

  const genVersion = () => {
    if (!(process.env.REACT_APP_STAGE.indexOf('PRD') >= 0)) {
      setTimeout(() => {
        const footerEle = document.getElementById('subportal-footer');
        footerEle.insertAdjacentHTML(
          'afterend',
          sanitizedHTML(`<div class="text-center" >Version : ${version}</div>`),
        );
      });
    }
  };

  return '';
};

const mapStateToProps = (state) => ({
  i18n: state.i18n,
  siteConfig: state.siteConfig,
});

const connectStore = connect(mapStateToProps, null, null, {
  pure: true,
})(Footer);

export { Footer as FooterComponent }; // <- For component Unit Test
export default connectStore;
